import React from "react";

import { NavBar } from "../components/NavBar";

function Mixer() {
  return (
    <div className="Mixer">
      <NavBar active="mixer" />
      Mixer
    </div>
  );
}

export default Mixer;
